import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { connectToJSContext } from "../utils.jsx";

import Footer from "../footer/index.jsx";
import Navigation from "../navigation/index.jsx";
import ContactForm from "../contact_form/index.jsx";
import Profile from "../profile/index.jsx";
import Locations from "../locations/index.jsx";
import Products from "../product_list/index.jsx";
import PostList from "../post_list/index.jsx";
import EventList from "../event_list/index.jsx";
import TeamMembers from '../team_members/index.jsx';
import MortgageCalculator from '../mortgage_calculator/index.jsx';
import ReviewTracker from '../review_tracker/index.jsx';
import EmailSubscription from '../email_subscription/index.jsx';
import { homeOrgCustomContentComponents, HomeUserCustomContent } from "../custom_content/index.jsx";
import { handleHomePageComponentMount } from "../../components/helpers.jsx";
import { HOME_PAGE } from '../constants';
import { Utils } from 'poly-js-utils';

const { customContent, customContentTwo, customContentThree } = homeOrgCustomContentComponents;

class HomePage extends React.Component {
    constructor(props) {
        super(props);
        const {
            showOrgCustomContent,
            showUserCustomContent,
            showMortgageCalculator,
            showEmailSubscription,
            showReviewTracker,
            maxProducts
        } = props;

        this.mapModuleNameToComponent = {
            [HOME_PAGE.MODULES.HOME_PROFILE]: Profile,
            [HOME_PAGE.MODULES.HOME_LOCATIONS]: Locations,
            [HOME_PAGE.MODULES.HOME_PRODUCTS]: Products,
            [HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT]: showOrgCustomContent && customContent,
            [HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT_TWO]: showOrgCustomContent && customContentTwo,
            [HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT_THREE]: showOrgCustomContent && customContentThree,
            [HOME_PAGE.MODULES.HOME_USER_CUSTOM_CONTENT]: showUserCustomContent && HomeUserCustomContent,
            [HOME_PAGE.MODULES.CONTACT_FORM]: ContactForm,
            [HOME_PAGE.MODULES.HOME_NEWS]: PostList,
            [HOME_PAGE.MODULES.HOME_EVENTS]: EventList,
            [HOME_PAGE.MODULES.HOME_TEAM]: TeamMembers,
            [HOME_PAGE.MODULES.MORTGAGE_CALCULATOR]: showMortgageCalculator && MortgageCalculator,
            [HOME_PAGE.MODULES.HOME_EMAIL_SUBSCRIPTION]: showEmailSubscription && EmailSubscription,
            [HOME_PAGE.MODULES.HOME_REVIEW_TRACKER]: showReviewTracker && ReviewTracker
        };

        this.componentsWithExtraProps = {
            [HOME_PAGE.MODULES.HOME_NEWS]: { limit: HOME_PAGE.VISIBLE_POSTS, showHeader: true },
            [HOME_PAGE.MODULES.HOME_EVENTS]: { limit: HOME_PAGE.VISIBLE_EVENTS, showHeader: true},
            [HOME_PAGE.MODULES.HOME_PRODUCTS]: { limit: maxProducts, showHeader: true }
        };
    }

    componentDidMount() {
        handleHomePageComponentMount();
    }

    render() {
        return (
            <div>
                <Navigation currentPage={''}/>
                <div id="maincontent">
                    {this.props.moduleOrder.map((moduleName, i) => {
                        const Component = this.mapModuleNameToComponent[moduleName];
                        if(_.has(this.componentsWithExtraProps, moduleName)) {
                            return Component && <Component {...this.componentsWithExtraProps[moduleName]} key={i} />;
                        }
                        return Component && <Component key={i} />;
                    })}
                    <Footer />
                </div>
            </div>
        );
    }
}

HomePage.defaultProps = {
    moduleOrder: [
        HOME_PAGE.MODULES.HOME_PROFILE,
        HOME_PAGE.MODULES.HOME_REVIEW_TRACKER,
        HOME_PAGE.MODULES.HOME_LOCATIONS,
        HOME_PAGE.MODULES.HOME_PRODUCTS,
        HOME_PAGE.MODULES.HOME_EMAIL_SUBSCRIPTION,
        HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT,
        HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT_TWO,
        HOME_PAGE.MODULES.HOME_ORG_CUSTOM_CONTENT_THREE,
        HOME_PAGE.MODULES.HOME_USER_CUSTOM_CONTENT,
        HOME_PAGE.MODULES.CONTACT_FORM
    ]
};

HomePage.propTypes = {
    showOrgCustomContent: PropTypes.bool,
    showUserCustomContent: PropTypes.bool,
    showMortgageCalculator: PropTypes.bool,
    maxProducts: PropTypes.number,
    moduleOrder: PropTypes.arrayOf(
        PropTypes.oneOf(_.values(HOME_PAGE.MODULES)).isRequired
    )
};

const mapStateToProps = (state) => ({
    showOrgCustomContent: !_.isEmpty(state.theme_data.home_page.custom_content ||
        state.theme_data.home_page.custom_content_2 ||
        state.theme_data.home_page.custom_content_3),
    showUserCustomContent: !_.isEmpty(state.profile.home_custom_content),
    showMortgageCalculator: !_.isEmpty(state.theme_data.is_wellsfargo),
    maxProducts: parseInt(state.theme_data.home_page.max_visible_products, 10),
    moduleOrder: state.theme_data.home_page.modules &&
        _.flatten(_.pluck(state.theme_data.home_page.modules, 'module')),
    showEmailSubscription: Utils.selectBoxIsTrue(
        state.theme_data.is_wellsfargo || state.theme_data.show_email_subscription
    ),
    showReviewTracker: Utils.selectBoxIsTrue(
        state.theme_data.is_wellsfargo || state.theme_data.show_review_tracker
    )
});

export default connectToJSContext(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./components/home_page/index.jsx